/**
 * 비디오의 특정 타임스탬프 프레임에서 포즈 랜드마크를 검출합니다.
 * @param {import('@mediapipe/tasks-vision').PoseLandmarker} landmarker
 * @param {HTMLVideoElement} videoElement
 * @param {number} timestamp
 */
export function detectPoseFrame(landmarker, videoElement, timestamp) {
  if (!landmarker || !videoElement || videoElement.readyState < 2) {
    return { landmarks: [], worldLandmarks: [] };
  }

  try {
    const result = landmarker.detectForVideo(videoElement, timestamp);
    return {
      landmarks: result.landmarks || [],
      worldLandmarks: result.worldLandmarks || [],
    };
  } catch (err) {
    console.error('[PoseDetect] 프레임 감지 오류:', err);
    return { landmarks: [], worldLandmarks: [] };
  }
}
